__turbopack_context__.v({
  "btn": "index-module__uzuPZa__btn",
  "modal": "index-module__uzuPZa__modal",
  "textWrapper": "index-module__uzuPZa__textWrapper",
});
